import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Модели автомобилей", -1)
const _hoisted_3 = { class: "base-form filter" }
const _hoisted_4 = { class: "base-form filter" }
const _hoisted_5 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _ctx.circleIcon,
                size: "large",
                onClick: _ctx.onAddVehicleModelClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новая модель автомобиля ")
                ]),
                _: 1
              }, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableFilterSearchQuery,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableFilterSearchQuery) = $event)),
                readonly: _ctx.tableLoading,
                clearable: "",
                max: "250",
                placeholder: "Поиск модели или марки автомобиля по названию"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "readonly"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_catalog_picker_component, {
                ref: "manufacturer",
                auth: "",
                modelValue: _ctx.tableFilterManufacturer,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableFilterManufacturer) = $event)),
                  _ctx.fetchVehicleModelsAsync
                ],
                placeholder: "Поиск марок автомобилей по названию",
                "search-url": "/api/vehiclemanufacturers/search"
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tableFilterManufacturer?.name), 1)
                ]),
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.name), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "row-key": "id",
              data: _ctx.tableData,
              sortable: "custom",
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
              onSortChange: _ctx.onTableSortingChange,
              onRowDblclick: _ctx.onTableRowDblClick
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Список моделей автомобилей пуст ☹️")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                (_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: (e) => _ctx.onTablePickVehicleClick(scope.row, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Выбрать ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "Модель",
                  prop: "name",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      underline: false,
                      type: "primary",
                      onClick: (e) => _ctx.onTableVehicleModelCellClick(scope.row, e)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Производитель" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", null, _toDisplayString(scope.row.manufacturer.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, null, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_button, {
                        icon: _ctx.deleteIcon,
                        size: "small",
                        type: "danger",
                        circle: "",
                        onClick: (e) => _ctx.onTableDeleteVehicleModelClick(scope.row, e)
                      }, null, 8, ["icon", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "default-sort", "onSortChange", "onRowDblclick"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}